import { render, staticRenderFns } from "./TrLogo.vue?vue&type=template&id=4b9519e9&scoped=true&"
import script from "./TrLogo.vue?vue&type=script&lang=ts&"
export * from "./TrLogo.vue?vue&type=script&lang=ts&"
import style0 from "./TrLogo.vue?vue&type=style&index=0&id=4b9519e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9519e9",
  null
  
)

export default component.exports